
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import BrandStory from './components/BrandStory';
import BrandValues from './components/BrandValues';
import TeamSection from './components/TeamSection';
import BrandMission from './components/BrandMission';
import ScrollToTopButton from '../../components/base/ScrollToTopButton';
import { useEffect } from 'react';

export default function About() {
  useEffect(() => {
    // 设置页面标题和meta信息
    document.title = '关于我们 - 燃轻元';
    
    // 更新meta描述
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '了解燃轻元的品牌故事、团队成员和企业使命。我们致力于用科学严谨的态度践行轻松哲学，让体重管理成为快乐的生活方式。');
    }
    
    // 添加Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "mainEntity": {
        "@type": "Organization",
        "name": "燃轻元",
        "description": "科学之下的轻松哲学，让体重管理成为一种快乐的生活方式",
        "url": import.meta.env.VITE_SITE_URL || "https://example.com",
        "foundingDate": "2024",
        "founder": [
          {
            "@type": "Person",
            "name": "张医生",
            "jobTitle": "首席科学顾问",
            "worksFor": {
              "@type": "Organization",
              "name": "北京燃轻元医疗技术研究院"
            }
          }
        ],
        "employee": [
          {
            "@type": "Person",
            "name": "李研究员",
            "jobTitle": "产品研发总监"
          },
          {
            "@type": "Person",
            "name": "王营养师",
            "jobTitle": "用户体验顾问"
          }
        ]
      }
    });
    
    // 移除之前的JSON-LD脚本
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }
    
    document.head.appendChild(script);
    
    return () => {
      // 清理
      const scriptToRemove = document.querySelector('script[type="application/ld+json"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <AboutHero />
      <BrandStory />
      <BrandValues />
      <BrandMission />
      <TeamSection />
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}
